/**** WARNING: This is a generated file, so any changes might get overwritten! ****/
const _t = (window as any).vvTranslations?.Bills || {};
export * from './Common.ts';
export const Page_Title = (): string => _t.Page_Title ?? "Legislation tracker";
export const Jurisdiction_Label = (): string => _t.Jurisdiction_Label ?? "Jurisdiction";
export const Category_Label = (): string => _t.Category_Label ?? "Category";
export const Uncategorized = (): string => _t.Uncategorized ?? "Uncategorized";
export const Loading_Error = (): string => _t.Loading_Error ?? "Unable to load legislation. Please try again.";
export const Back_To_Bills = (): string => _t.Back_To_Bills ?? "Back to bills";
export const Detail_Summary = (): string => _t.Detail_Summary ?? "Description";
export const Detail_Our_Position = (): string => _t.Detail_Our_Position ?? "Our position";
export const Detail_Category_Label = (): string => _t.Detail_Category_Label ?? "Category";
export const Detail_Session = (): string => _t.Detail_Session ?? "Session";
export const Detail_Sponsors = (): string => _t.Detail_Sponsors ?? "Sponsors";
export const Detail_Cosponsors = (count: string): string => {
  const override: string = _t.Detail_Cosponsors;
  const args = {count};
  const msg: string =
    override ? replaceParameters(override, args) 
    : `${count} cosponsors`;
  return msg;
}
;
export const Detail_Legislative_Actions = (): string => _t.Detail_Legislative_Actions ?? "Legislative actions";
export const Detail_Committees = (): string => _t.Detail_Committees ?? "Committees / subcommittees";
export const Detail_Related_Bills = (): string => _t.Detail_Related_Bills ?? "Related bills";
export const Detail_More_Information = (): string => _t.Detail_More_Information ?? "More information";
export const Detail_Error = (): string => _t.Detail_Error ?? "Unable to load this bill. Please try again.";
export const View_Profile = (): string => _t.View_Profile ?? "View profile";
export const Opens_In_New_Tab = (): string => _t.Opens_In_New_Tab ?? "opens in a new tab";
export const Show_More = (): string => _t.Show_More ?? "Show more";
export const Show_Less = (): string => _t.Show_Less ?? "Show less";
export const Loading = (): string => _t.Loading ?? "Loading…";
export const Download_Csv = (): string => _t.Download_Csv ?? "Download CSV";
export const Position_Statement_Support = (): string => _t.Position_Statement_Support ?? "We support this bill";
export const Position_Statement_Oppose = (): string => _t.Position_Statement_Oppose ?? "We oppose this bill";
export const Position_Statement_Neutral = (): string => _t.Position_Statement_Neutral ?? "We are monitoring this bill";
export const Position_Support = (): string => _t.Position_Support ?? "Supporting";
export const Position_Oppose = (): string => _t.Position_Oppose ?? "Opposing";
export const Position_Neutral = (): string => _t.Position_Neutral ?? "Monitoring";
export const Key_Legislation_Header = (): string => _t.Key_Legislation_Header ?? "Key Legislation";
export const Search_Placeholder = (): string => _t.Search_Placeholder ?? "Search by keyword or bill number";
export const Search_Button = (): string => _t.Search_Button ?? "Search";
export const Search_Results_Count = (shown: string, total: string): string => {
  const override: string = _t.Search_Results_Count;
  const args = {shown,total};
  const msg: string =
    override ? replaceParameters(override, args) 
    : `Displaying ${shown} of ${total} bills matched`;
  return msg;
}
;
export const Search_Results_None = (): string => _t.Search_Results_None ?? "0 bills matched";
export const Search_Results_Empty = (): string => _t.Search_Results_Empty ?? "No bills matched your search. Try different keywords or a bill number such as HB 1.";
export const Search_Error = (): string => _t.Search_Error ?? "Error fetching search results. Please try again.";
export const Multiple_Sessions = (): string => _t.Multiple_Sessions ?? "Multiple Sessions";
export const Clear_Search = (): string => _t.Clear_Search ?? "Clear search";
export const Key_Legislation_In = (): string => _t.Key_Legislation_In ?? "in";
export const All_Tab = (): string => _t.All_Tab ?? "All";
export const Position_Filter_Label = (): string => _t.Position_Filter_Label ?? "Filter by our position";
export const Reset_View = (): string => _t.Reset_View ?? "Reset view";
export const Filtered_Empty = (): string => _t.Filtered_Empty ?? "No key bills match these filters.";
export const Search_Results_For = (keywords: string, jurisdiction: string): string => {
  const override: string = _t.Search_Results_For;
  const args = {keywords,jurisdiction};
  const msg: string =
    override ? replaceParameters(override, args) 
    : `Results for “${keywords}” in ${jurisdiction}`;
  return msg;
}
;
export const Back_To_Key_Legislation = (): string => _t.Back_To_Key_Legislation ?? "Back to key legislation";
export const Bill_Navigation_Label = (): string => _t.Bill_Navigation_Label ?? "Browse bills";
export const Bill_Position_Of = (index: string, total: string): string => {
  const override: string = _t.Bill_Position_Of;
  const args = {index,total};
  const msg: string =
    override ? replaceParameters(override, args) 
    : `${index} of ${total}`;
  return msg;
}
;
export const Previous = (): string => _t.Previous ?? "Previous";
export const Next = (): string => _t.Next ?? "Next";
export const Previous_Bill = (): string => _t.Previous_Bill ?? "Previous bill";
export const Next_Bill = (): string => _t.Next_Bill ?? "Next bill";
export const Show_All_Actions = (count: string): string => {
  const override: string = _t.Show_All_Actions;
  const args = {count};
  const msg: string =
    override ? replaceParameters(override, args) 
    : `Show all ${count} actions`;
  return msg;
}
;
export const Show_Fewer_Actions = (): string => _t.Show_Fewer_Actions ?? "Show fewer actions";
export const Show_All_Related_Bills = (count: string): string => {
  const override: string = _t.Show_All_Related_Bills;
  const args = {count};
  const msg: string =
    override ? replaceParameters(override, args) 
    : `Show all ${count} related bills`;
  return msg;
}
;
export const Show_Fewer_Related_Bills = (): string => _t.Show_Fewer_Related_Bills ?? "Show fewer related bills";
export const Official_Not_Available = (): string => _t.Official_Not_Available ?? "A profile isn't available for this official.";
export const Back_To_Bill = (): string => _t.Back_To_Bill ?? "Back to bill";
export const Official_Load_Error = (): string => _t.Official_Load_Error ?? "Unable to load this official's profile. Please try again.";
